import api from '../../api';
import config from '../../config';
// const { DOMAIN_KEY } = process.env;
export default {
    get: (params=null) => {
        // return api.request('get',config.default.jobDetaills+'?$limit=10&$sort[createdAt]=-1', null, null, null)
        // console.log(params);
        return api.request('get',config.default.jobDetaills, null, params, null)
    }
}